module.exports = __webpack_public_path__ + "images/emoji/waning_gibbous_moon.767de63527d0635972da.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/waning_gibbous_moon.png
// module id = CHhd
// module chunks = 13